export const reportsPath = "/app/reports";
export const reportsCategoryPath = "/app/reports/category";

export const reportVarientsMeta = {
  favoriteReports: {
    label: "Favorites",
    varient: "favoriteReports",
    key: "REPORTS_FAVOURITE",
    url: reportsPath + "/favourites",
    path: reportsPath + "/favourites",
  },
  customReports: {
    label: "Custom Reports",
    varient: "customReports",
    key: "REPORTS_CUSTOM",
    url: reportsPath + "/custom-reports",
    path: reportsPath + "/custom-reports",
  },
  scheduleReports: {
    label: "Schedules",
    varient: "scheduleReports",
    key: "REPORTS_SCHEDULE",
    url: reportsPath + "/schedule-reports",
    path: reportsPath + "/schedule-reports",
  },
  category: {
    key: "REPORTS_CATEGORY",
    url: reportsCategoryPath+"/*",
    path: reportsCategoryPath,
  },
};

export const reportsRouteMeta = Object.values(reportVarientsMeta);